export default {
  INIT: {
    START: 'APP/INIT/START',
    SUCCESS: 'APP/INIT/SUCCESS',
    FAILURE: 'APP/INIT/FAILURE'
  }
}
